import { DASHBOARD_ERROR, GETTING_DASHBOARD_DATA, GET_DASHBOARD_DATA } from "../types"

const initialState = {
    dashboardData: null,
    loadingDashboard: true,
    dashboardError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case GETTING_DASHBOARD_DATA:
        return {
            ...state,
            loadingDashboard: action.payload,
        }
        case GET_DASHBOARD_DATA:
        return{
            ...state,
            loadingDashboard: false,
            dashboardError: null,
            dashboardData: action.payload,
        }
        case DASHBOARD_ERROR:
        return{
            ...state,
            loadingDashboard: false,
            dashboardError: action.payload
        }
        default: return state
    }
}
